module.exports = __webpack_public_path__ + "static/media/creditCardRightSideBG1.d843bc07.svg";